@if (text()) {
  <button
    mat-icon-button
    type="button"
    #tooltipElement="matTooltip"
    [matTooltip]="text()"
    (click)="tooltipElement.show()"
  >
    <fa-icon icon="question-circle"></fa-icon>
  </button>
}
